<div class= progress-bar>
  <div 
    class="progress-bar__done"
    [style.width]="percentage">
  </div>
</div>